export { ProfileAvatar } from './src/profile-avatar';
